module.exports = __webpack_public_path__ + "media/images/filter_ic-13cc2bafe1429e3f6137395bb22a1035.svg";